export const generateNewName = (revisions, currentRevision, language) => {
    const similar = revisions.filter((r) => r.includes(`${currentRevision}_${language}`)).length;
    for (let i = 1; i <= similar; i += 1) {
        const equal = revisions.filter((r) => r === `${currentRevision}_${language} (${i})`).length;
        if (equal === 0)
            return `${currentRevision}_${language} (${i})`;
    }
    return `${currentRevision}_${language}`;
};
